import React from "react";

import Button from "../Button";
import WarningImg from '../../assets/images/warning.png';

import "./NotificationAlertCard.css";

function NotificationAlertCard({ handleClosePopup = null, hideIcon = false, message = "Seems there is some problem with your network, please check back in a while.", heading = "Oops!", negativeButtonTitle = "Close", positiveButtonTitle = "OK", handlePositiveClick = null }) {
  return (
    <div className="notifctonAlrtCrd">
      {hideIcon && <span className="warningImg"><img src={WarningImg}/></span>}
      <h3 className="notifctonAlrtCrd__hdng">
        {heading} <br />
      </h3>
      <p className="notifctonAlrtCrd__desc">
        {
          message.split("\n").map(function(item, idx) {
              return (
                  <span key={idx}>
                      {item}
                      <br/>
                  </span>
              )
          })
        }
      </p>
      {handlePositiveClick && <div className="append-top30">
        <Button title={positiveButtonTitle} handleClick={handlePositiveClick} isClickMode />
      </div>}
      <div className="append-top30">
        <button className="btn__grey" onClick={handleClosePopup} isClickMode>{negativeButtonTitle}</button>
      </div>
      {/* <button className="notifctonAlrtCrd__btn" onClick={handleClosePopup}>
        close
      </button> */}
    </div>
  );
}

export default NotificationAlertCard;
